import { Skeleton } from '@/components/ui/skeleton';

function SkeletonRow() {
  return (
    <div className="flex items-center h-14 px-6 border-b border-table-row-border">
      <div className="w-[48px] pr-2">
        <Skeleton className="h-4 w-4 rounded" />
      </div>
      <div className="w-[160px] pr-4">
        <Skeleton className="h-4 w-24" />
      </div>
      <div className="flex-1 min-w-0 pr-4">
        <Skeleton className="h-4 w-32" />
      </div>
      <div className="w-[160px] pr-4">
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="w-[110px] pr-4">
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
      <div className="w-[140px] pr-4">
        <Skeleton className="h-4 w-24" />
      </div>
      <div className="w-[110px] pr-4">
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="w-[140px] pr-4">
        <Skeleton className="h-8 w-full rounded" />
      </div>
      <div className="w-[110px]">
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  );
}

export function PolicyTableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <SkeletonRow key={i} />
      ))}
    </>
  );
}
